"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[70167],{

/***/ 70167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CardProcessor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CardProcessor() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "mt-10 lg:mt-16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-center text-xl font-bold lg:text-3xl mb-8 lg:mb-10",
                children: "What Is a Credit Card Processor?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center font-light text-sm lg:text-base",
                children: "A credit card processor is a company or financial institution that facilitates credit card transactions between the merchant and the customer. In today's digital age, transactions can occur anywhere - in person, online, over the phone, or by mail. The processor acts as a middleman, transmitting transaction data between the merchant, the customer, and the various entities involved in the payment process, such as the card network, the issuing bank, and the acquiring bank. The credit card processor also ensures the transaction is secure, verifies the card's validity, and approves or declines the payment. The processor charges a fee to the merchant for their services, typically a percentage of the transaction amount, and may also charge additional fees for specific services or transactions."
            })
        ]
    });
}


/***/ })

}]);